export default "__VITE_ASSET__BKfQdgIs__"